export const Resident = () => {
  return <></>;
};
